import { createSelector } from "reselect";
import { RootState } from "../store";
import { SiderState } from "./sider.reducer";
const selectCartReducer = (state: RootState): SiderState => state.sider;

export const selectSiderCollapsed = createSelector(
  [selectCartReducer],
  (sider) => sider.siderCollapsed
);

export const selectOpenKeys = createSelector(
  selectCartReducer,
  (sider) => sider.openKeys
);
